import { setupFormState } from '@workwave-tidal/core/form'
import { DriverAssignmentFormState } from './typings'

export const formState = setupFormState<DriverAssignmentFormState, ''>('', {
  id: 'driverAssignmentForm',
  initialValues: { assignments: {} },
})
